import dynamic from 'next/dynamic'

export const DynamicFullSizeMobileMenuModal = dynamic(
  () => import('.').then((mod) => mod.FullSizeMobileMenuModal),
  { ssr: false },
)
